import { ReactElement } from 'react';

import { FiscalPrintEnabledQuery } from '@dreryk/egabinet-invoice-frontend-api';

import { useCqrsFind } from '@dreryk/command-query-react-common';
import { commonTranslationKeys } from '@dreryk/react-common';
import { Message, MessageType } from '@dreryk/react-components';

import { protectFeature } from '~libs.shared.system';

type VisitSettlementPaymentModalLoaderRenderProps = { fiscalPrintEnabled: boolean };
type VisitSettlementPaymentModalLoaderProps = {
   readonly children: (renderProps: VisitSettlementPaymentModalLoaderRenderProps) => ReactElement;
};

export const VisitSettlementPaymentModalLoader = (
   props: VisitSettlementPaymentModalLoaderProps
): ReactElement | null => {
   const invoiceCreateAvailable = protectFeature('creatingInvoices');

   const {
      data: fiscalPrintEnabled,
      loading: fiscalPrintEnabledLoading,
      error: fiscalPrintEnabledError,
   } = useCqrsFind(() => new FiscalPrintEnabledQuery(), { enabled: invoiceCreateAvailable });

   if (fiscalPrintEnabledLoading) {
      return null;
   }

   if (fiscalPrintEnabledError) {
      return (
         <Message
            testId={'visitSettlementPaymentModalLoaderError'}
            type={MessageType.NEGATIVE}
            label={commonTranslationKeys.unexpectedErrorHasOccurred}
            displayIndicator
         />
      );
   }

   return props.children({
      fiscalPrintEnabled: Boolean(fiscalPrintEnabled),
   });
};
